import type { DocSection, DocGroup, DocHeading } from "@/site-kit/types";
import IntroductionMdx from "@/content/docs/aiapps-framework/getting-started/introduction.mdx";
import QuickstartMdx from "@/content/docs/aiapps-framework/getting-started/quickstart.mdx";
import metadata from "./docs-metadata.json";

type MetadataEntry = {
  headings: DocHeading[];
  rawContent: string;
};

const meta = metadata as Record<string, MetadataEntry>;

export const docGroups: DocGroup[] = [
  {
    label: "Getting Started",
    sections: [
      {
        id: "introduction",
        title: "Introduction",
        Component: IntroductionMdx,
        headings: [...(meta.introduction?.headings ?? [])],
        rawContent: meta.introduction?.rawContent ?? "",
      },
      {
        id: "quickstart",
        title: "Quickstart",
        Component: QuickstartMdx,
        headings: [...(meta.quickstart?.headings ?? [])],
        rawContent: meta.quickstart?.rawContent ?? "",
      },
    ],
  },
];

export const allSections: DocSection[] = docGroups.flatMap((g) => g.sections);
